<template>
    <div>
    <v-card class="mx-auto" light :loading="loading">
    <v-card-title> Expedientes
    <div class="flex-grow-1"></div>
   
    </v-card-title>
    <div style=" display: flex; align-items: center; justify-content: end;"> 
      <v-col cols="6" >
        <v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Buscar"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </div>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="expedientes"
                :search="search"
                locale="es-mx"
                :footer-props="{
                    'items-per-page-all-text':'Todos',
                    'items-per-page-text':'Columnas'
                }"
            >
             <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.name">
                    <td>
                        <a href="javascript: void(0)" class="link" @click="verExpediente(item)"><span v-html="(item.clave)"></span></a>
                    </td>


                        <td>{{fecha(item.fechaApertura)}}</td>
                        <td>{{item.fechaCierre? fecha(item.fechaCierre) : 'No ha sido cerrado'}}</td>
                        <td>{{item.elaboro.nombreCompleto}}</td>
                        <td>{{item.unidadAdministrativa.nombre}}</td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card-text>
        
            
    </v-card>
    <ver-expediente v-if="mostrar" :mostrar="mostrar" @cancelar="mostrar = false" :expediente="expediente"
            :ver="true" />
    </div>
</template>
<script>
import { getExpedientes,getOficoPadre } from "./archivo.service"
import VerExpediente from '../expedientes/agregarExpediente.vue';
import { DateTime } from 'luxon';


export default {
    components: {
        VerExpediente
    },
    data: () => ({
        loading: false,
        search: null,
        agregar: false,
        modificar: {
            mostrar: false,
            dependencia: null
        },
        headers: [
            { text: 'Clave', value: 'clave' },
            { text: 'Fecha de apertura', value: 'fechaApertura' },
            { text: 'Fecha de cierre', value: 'fechaCierre' },
            { text: 'Capturó', value: 'elaboro.nombreCompleto' },
            { text: 'Dependencia', value: 'unidadAdministrativa.nombre' },
           
            
           
        ],
        // menuItems: [
        //      {text:'item', action: 'item'}
        // ],
        expedientes:[],
        expediente:null,
        mostrar:false

        

    }),
    computed: {
        
    },
    async created(){
        try{
            this.loading = true
            const serverResponse = await getExpedientes()
            this.loading= false
            if(!serverResponse.expedientes) throw new Error(serverResponse.mensaje)
            this.expedientes = serverResponse.expedientes
        }catch(error){
            // console.log(error)
            this.$notificarError(error);
        }
    },
    methods: {
         menuAction(action, id){
            switch(action){
                case 'item':
                  
                    break;
                default: break
            }
        },
       fecha(fecha){
            return fecha ? DateTime.fromISO(fecha).toFormat('dd - MM - yyyy'): '';
        },
        async verExpediente(expediente) {
            try {
                const { _id } = expediente;
                const serverResponse = await getOficoPadre(_id);
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje)
                const { oficio } = serverResponse;
                this.$router.push(`/oficios/${oficio.type}/${oficio._id}`);
            } catch (error) {
                this.$notificarError(error);
            }
        },

        
    }
}
</script>
